import {StorageKey} from "enum/StorageKey";
import {PortfolioType} from "enum/PortfolioType";
import Utils from "platform/util/Utils";

export class Preference<T> {

    private _value: T;

    public set value(value: T) {
        this._value = value;
    }

    public get value(): T {
        return this._value;
    }

    public static Of = <T>(value: T): Preference<T> => {
        const preference: Preference<T> = new Preference();
        preference.value = value;
        return preference;
    }

    public static serialize = <T>(key: StorageKey, preference: Preference<T>): string => {
        if (key === StorageKey.PortfolioSort) {
            return JSON.stringify(preference.value);
        }
        return preference.value.toString();
    }

    public static deserialize = <T>(key: StorageKey, value: string): Preference<T> => {
        const preference: Preference<T> = new Preference<T>();
        if (key === StorageKey.PortfolioSort) {
            preference.value = PortfolioType.deserialize(value) as any;
        } else if (key === StorageKey.ShowChart) {
            preference.value = Utils.parseBoolean(value) as any;
        } else if (key === StorageKey.ChartMobileY) {
            preference.value = Utils.parseNumber(value) as any;
        } else if (key === StorageKey.PopupSound || key === StorageKey.Emails || key === StorageKey.PhoneCalls || key === StorageKey.PushNotifications || key === StorageKey.SMS) {
            preference.value = Utils.parseBoolean(value) as any;
        }
        return preference;
    }
}
